import { render, staticRenderFns } from "./OpendataWizardWrapper.vue?vue&type=template&id=e4c8f024&"
import script from "./OpendataWizardWrapper.vue?vue&type=script&lang=js&"
export * from "./OpendataWizardWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports